module.exports = __webpack_public_path__ + "static/img/1383_phase_function_Paper_PointsHejduk_Prediction.7446dcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1383_phase_function_Paper_PointsHejduk_Prediction.png
// module id = m0uY
// module chunks = 0